"use client";

import { CopyLinkButton } from "./CopyLinkButton";
import { EllipsisMenu } from "./EllipsisMenu";

interface PostCardActionsProps {
  showCopyLink?: boolean;
  showEllipsis?: boolean;
  onCopyLink?: () => void;
  copied?: boolean;
  ellipsisMenuOpen: boolean;
  onEllipsisMenuOpen: () => void;
  onEllipsisMenuClose: () => void;
  onDelete: () => void;
}

/**
 * Shared action buttons component for post cards
 * Combines copy link button and ellipsis menu
 * Used in thread pages and My Posts page
 */
export function PostCardActions({
  showCopyLink = false,
  showEllipsis = false,
  onCopyLink,
  copied = false,
  ellipsisMenuOpen,
  onEllipsisMenuOpen,
  onEllipsisMenuClose,
  onDelete,
}: PostCardActionsProps) {
  // Don't render anything if no actions are available
  if (!showCopyLink && !showEllipsis) {
    return null;
  }

  return (
    <div className="flex gap-2">
      {showCopyLink && onCopyLink && (
        <CopyLinkButton onCopy={onCopyLink} copied={copied} />
      )}
      {showEllipsis && (
        <EllipsisMenu
          isOpen={ellipsisMenuOpen}
          onOpen={onEllipsisMenuOpen}
          onClose={onEllipsisMenuClose}
          onDelete={onDelete}
        />
      )}
    </div>
  );
}
